var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoronavirusCta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "89px",
    height: "89px",
    viewBox: "0 0 89 89",
    style: {
      enableBackground: "new 0 0 89 89"
    },
    xmlSpace: "preserve",
    "aria-labelledby": titleId,
    role: "img",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Coronavirus CTA Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M23.4,75.6c0.4-1.6,1.5-3.2,2.8-4.1c1.3-0.9,3.2-1.2,4.9-0.9l12.7,3.1c0.4-1.6,1.6-3.5,3.2-4.1l6.3-2.5 c0.6-1.5,2.5-4.1,6.9-5.7c5.6-2.2,9.3-0.7,9.9-0.3l2.8,1.5l0.1-2.5l12.9,1.6l-2.8,23.8l-12.9-1.6l0.1-2.5L51,89L28,82.9 C24.7,82.2,22.7,78.8,23.4,75.6z M79.9,81.7l1.8-16.4l-5.4-0.6l-1.6,16.4L79.9,81.7z M29,79.4l21.9,5.8l20.3-7.7l1.2-10.6 L68.3,65l0,0v-0.1c-0.3,0-2.5-1-6.9,0.7c-4.1,1.6-4.9,3.6-4.9,4.1l-0.1,1l-8.1,3.1c-0.9,0.3-1.2,1.3-0.9,2.2 c0.3,0.9,1.3,1.3,2.1,1L60,73l1.3,3.6l-10.6,3.9c-2.5,0.9-5.1,0-6.5-2.3l-14.1-3.5c-0.6-0.1-1.3,0-1.9,0.4c-0.6,0.3-1,0.9-1,1.6 C26.9,77.8,27.5,79,29,79.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M87.4,27.2H75.2c-0.9,0-1.5-0.7-1.5-1.5v-4.5H47.5c-0.9,0-1.5,0.7-1.5,1.5v9c0,0.9-0.7,1.5-1.5,1.5H32.4 c-0.9,0-1.5-0.7-1.5-1.5v-9C30.9,13.5,38.4,6,47.8,6h26V1.5c0-0.9,0.7-1.5,1.5-1.5h12.2C88.4,0,89,0.7,89,1.5v24.3 C88.9,26.6,88.1,27.2,87.4,27.2z M43,30.2v-3.1h-9.1v3.1H43z M33.7,22.7v1.5h9.1v-1.5c0-2.5,2.1-4.5,4.6-4.5h19.9v-9H47.5 C39.9,9.2,33.7,15.3,33.7,22.7z M70.5,9.2v9h3.1v-9H70.5z M85.8,3.1h-9.1v21.2h9.1V3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M46,36.4H43v28.8H46V36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.9,39.4h-3.1v34.9h3.1V39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M33.7,36.4h-3.1v28.8h3.1V36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCBC00",
    d: "M6.2,47c3.4,0,6.2,2.8,6.2,6.1c0,3.3-2.8,6.1-6.2,6.1S0,56.4,0,53.1C0,49.7,2.8,47,6.2,47z M6.2,56.1 c1.6,0,3.1-1.3,3.1-3.1S7.9,50,6.2,50s-3.1,1.3-3.1,3.1S4.4,56.1,6.2,56.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCBC00",
    d: "M16.9,44.1c-4.3,0-7.6-3.3-7.6-7.6s3.4-7.6,7.6-7.6s7.6,3.3,7.6,7.6S21,44.1,16.9,44.1z M16.9,31.8 c-2.5,0-4.6,2-4.6,4.5s2.1,4.5,4.6,4.5s4.6-2,4.6-4.5S19.4,31.8,16.9,31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCBC00",
    d: "M7.8,7.7c4.3,0,7.6,3.3,7.6,7.6s-3.4,7.6-7.6,7.6s-7.6-3.3-7.6-7.6S3.5,7.7,7.8,7.7z M7.8,19.8 c2.5,0,4.6-2,4.6-4.5s-2.1-4.5-4.6-4.5s-4.6,2-4.6,4.5S5.1,19.8,7.8,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCBC00",
    d: "M12.4,59c0.7,0,1.5,0.1,2.1,0.3c1.2-2.8,4-4.8,7.1-4.8c4.3,0,7.6,3.3,7.6,7.6H26c0-2.5-2.1-4.5-4.6-4.5 c-2.2,0-4.3,1.7-4.6,3.9c0,0.4-0.3,0.9-0.7,1.2c-0.4,0.3-0.9,0.3-1.3,0c-0.9-0.4-1.6-0.6-2.5-0.6c-3.4,0-6.2,2.8-6.2,6.1 c0,1.6,0.6,3.1,1.8,4.2c0.6,0.6,0.6,1.6,0,2.2c-1.2,1.2-1.8,2.6-1.8,4.2c0,3.3,2.8,6.1,6.2,6.1V88c-5,0-9.1-4.1-9.1-9 c0-1.9,0.6-3.8,1.8-5.2c-1.2-1.6-1.8-3.3-1.8-5.2C3.1,63.1,7.2,59,12.4,59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCBC00",
    d: "M22.8,73.7l-3.1-9.2l-2.9,1l3.1,9.2L22.8,73.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCBC00",
    d: "M21.5,77.2h-9.1v3.1h9.1C21.5,80.3,21.5,77.2,21.5,77.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoronavirusCta);
export default __webpack_public_path__ + "static/media/coronavirus-cta.cd200a3f6bbfca8e763eccebe6274578.svg";
export { ForwardRef as ReactComponent };